import GuidedOnboardingDataManagerPopularTour from 'webapp/models-custom/tour/guided-onboarding/data-manager-popular';
import GuidedOnboardingDataManagerSelectedTour from 'webapp/models-custom/tour/guided-onboarding/data-manager-selected';
import GuidedOnboardingMetricsTour from 'webapp/models-custom/tour/guided-onboarding/metrics';
import GuidedOnboardingWizardTour from 'webapp/models-custom/tour/guided-onboarding/wizard';

export {
	GuidedOnboardingDataManagerPopularTour,
	GuidedOnboardingDataManagerSelectedTour,
	GuidedOnboardingMetricsTour,
	GuidedOnboardingWizardTour,
};
